import React from 'react'

// helper & utility functions, especially those that are common to multiple APIs.
export const FormContext = React.createContext()
export const ScrollTopContext = React.createContext()
